import { locale, chooseLocale } from '../../translations';

const messages = chooseLocale(locale);

const nicknameValidation = (nickname) => {
  if (!nickname) return messages['profile.message.nickname'];

  return '';
};

const avatarFileNameValidation = (avatarFileName) => {
  if (!avatarFileName) return messages['profile.message.avatar_file_name'];

  return '';
};

class Validation {
  static formValidate = (type, value) => {
    switch (type) {
      case 'nickname':
        return nicknameValidation(value);
      case 'avatarFileName':
        return avatarFileNameValidation(value);
      default:
        return '';
    }
  };
}

export default Validation;
